import { render, staticRenderFns } from "./select-vue.vue?vue&type=template&id=56876067&"
import script from "./select-vue.vue?vue&type=script&lang=js&"
export * from "./select-vue.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../visual/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports